import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { DEFAULT_SITE_STYLE } from '../../cms/siteCmsTypes';
import { normalizeSiteStyle } from '../../cms/siteStyle';
import { techPageVariables } from '../../cms/techPageStyle';
import { buildSiteCmsCss } from '../../cms/siteCmsStyleRuntime';
import { foregroundFor, paletteFor, siteBackgroundFor } from '../../cms/siteCmsPalettes';
import PublicHeaderV2 from './PublicHeaderV2';
import PublicFooter from '../PublicFooter';
import '../../tech-page.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TechPageBoundary = ({ children, pageClassName = '' }) => {
  const [siteStyle, setSiteStyle] = useState(() => normalizeSiteStyle(DEFAULT_SITE_STYLE));

  useEffect(() => {
    let active = true;
    axios.get(`${BACKEND_URL}/api/v2/public/site-style`)
      .then(response => {
        if (active) setSiteStyle(normalizeSiteStyle(response.data?.style || DEFAULT_SITE_STYLE));
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const variables = useMemo(() => techPageVariables(siteStyle, siteStyle.tech), [siteStyle]);
  const publicCss = useMemo(() => buildSiteCmsCss(siteStyle), [siteStyle]);
  const siteBackground = useMemo(() => siteBackgroundFor(siteStyle), [siteStyle]);
  const siteForeground = useMemo(() => foregroundFor(paletteFor(siteStyle), siteBackground), [siteStyle, siteBackground]);
  const techClassName = ['nx-site-cms', 'nx-tech-page', pageClassName].filter(Boolean).join(' ');

  return (
    <div
      className="nx-public-site min-h-screen"
      style={{
        backgroundColor: siteBackground,
        color: siteForeground,
      }}
    >
      <style dangerouslySetInnerHTML={{ __html: publicCss }} />
      <PublicHeaderV2 style={siteStyle} />
      <main className="nx-public-page-content">
        <div
          className={techClassName}
          data-palette={siteStyle.paletteId}
          style={{
            ...variables,
            backgroundColor: siteBackground,
            color: siteForeground,
          }}
        >
          {children}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default TechPageBoundary;
